import { useState, useEffect } from 'react';
import { BrokerClientApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { BfiDataGrid, Column, formatDateTime } from '@apply/ui';
import { GridSettingType } from '@apply/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const PrincipalBClientsTable = ({ principalId, gridStore }) => {
    const bclientApi = new BrokerClientApi.BrokerClientApi(applicationInsights);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = (criteria) => bclientApi.getPrincipalBClients(principalId, criteria);

    const styles = {
        dateTable: { marginBottom: '0' },
        dateColumn1: { padding: '3px' },
        dateColumn2: { padding: '3px', width: '100px' },
    };

    useEffect(() => {
        if (gridStore && principalId) {
            gridStore.setOnLoad('id', dataFunction, null);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onDownloadIcca = (e) => {
        if (!e.value) {
            return;
        }
        return (
            <a
                href={e.value}
                target='_blank'
                rel='noreferrer'
            >
                <FontAwesomeIcon
                    icon={faDownload}
                    style={{ color: 'mediumblue', cursor: 'pointer' }}
                />
            </a>
        );
    };

    const onBrokerRender = (e) => {
        return (
            <div style={{ textAlign: 'left' }}>
                {e.data.brokerPersonName && (
                    <div>
                        <b>{e.data.brokerPersonName}</b>
                    </div>
                )}
                {e.data.brokerBusinessName && (
                    <div>
                        <b>{e.data.brokerBusinessName}</b>
                    </div>
                )}
                {e.data.brokerAddress && (
                    <div>
                        {e.data.brokerAddress.street1}
                        {e.data.brokerAddress.street2 && <div style={{ textAlign: 'left' }}>{e.data.brokerAddress.street2}</div>}
                        {(e.data.brokerAddress.city || e.data.brokerAddress.state || e.data.brokerAddress.zipCode) && (
                            <div>
                                {e.data.brokerAddress.city}, {e.data.brokerAddress.state} {e.data.brokerAddress.zipCode}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const onDatesRender = (e) => {
        return (
            <table
                padding='0'
                spacing='0'
                style={styles.dateTable}
            >
                <tbody>
                    {e.data.history.map((evnt, index) => {
                        return (
                            <tr key={'row' + index}>
                                <td style={styles.dateColumn1}>{evnt.event}:</td>
                                <td style={styles.dateColumn2}>{formatDateTime(evnt.dateTime)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    };
    if (!gridStore || !principalId) {
        return null;
    }

    return (
        <BfiDataGrid
            gridType={GridSettingType.PrincipalBClients}
            defaultPageSize={25}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            noDataText='No  B-Clients found'
        >
            <Column
                dataField='status'
                caption='Status'
                alignment='left'
                width={130}
            />
            <Column
                caption='Broker'
                alignment='left'
                cellRender={onBrokerRender}
            />
            <Column
                caption='History'
                alignment='left'
                cellRender={onDatesRender}
                width={270}
            />
            <Column
                dataField='clientFeeType'
                caption='Fee'
                width={50}
                alignment='left'
            />
            <Column
                dataField='iccaDownloadUrl'
                caption='ICCA'
                width={60}
                alignment='center'
                cellRender={onDownloadIcca}
            />
        </BfiDataGrid>
    );
};

export default PrincipalBClientsTable;
